// eslint-disable-next-line import/prefer-default-export
export const auth0Config = {
  domain:
    window.location.origin === 'https://ltda.lely.cloud'
      ? 'auth.lely.cloud'
      : 'auth-dev.lely.cloud',
  clientId:
    window.location.origin === 'https://ltda.lely.cloud'
      ? 'KjZNtN2O3MbBNdtqMKWajvEp3MBzBdkX'
      : 'MkyXM60lqcgPunHBfySEhmvxcgqutkum',
  audience: 'ltda-api',
  redirectUri: `${window.location.origin}/auth/callback`,
  logoutRedirectUri: `${window.location.origin}`,
};

// Helper function to get client ID consistently
export const getAuth0ClientId = () => auth0Config.clientId;
